import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=0133441e&scoped=true"
import script from "./paginator.vue?vue&type=script&lang=js"
export * from "./paginator.vue?vue&type=script&lang=js"
import style0 from "./paginator.vue?vue&type=style&index=0&id=0133441e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133441e",
  null
  
)

export default component.exports